export default "float quinticIn(float t) {\n  return pow(t, 5.0);\n}\n\n"